import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Menu} from "../models/menu";
import {PromotionServiceService} from "@core/shared/services/promotion-service.service";

@Injectable({
    providedIn: 'root'
})
export class PromotionServiceItemResolver  {

    constructor(
        private _promotionServiceService: PromotionServiceService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._promotionServiceService.getItemAPI(parseInt(route.paramMap.get('id')));
    }
}
